<!--
	TEMPLATE
-->
<style>
.editable-photos__photo {

    width: 150px;
    height: 150px;
    background-size: cover;
    background-position: 50%;
    background-color: #494949;
    margin: 10px;
    border: 2px solid #424f65;
    border-radius: 6px;

}
</style>
<template>
<div class="editable-input">
  <div v-if="input" class="editable-photos__photo" :style="{backgroundImage: 'url('+s3url(input, 'small')+')'}"></div>
	<div :class="{'text-center': isEditView}">
		<span v-if="!input">No image uploaded</span>
	</div>

	<div v-if="isEditView">
		<s3 v-model="input" extensions=".png, .jpeg, .jpg, .pdf, .PNG, .JPEG, .JPG" :single="true" label="Change Image"></s3>
	</div>
</div>
</template>

<!--
	SCRIPT
-->
<script>
import utils from '@/libs/mixins.js';
import vModelNested from '@/libs/vModelNested.js';
import S3 from '../../components/S3.vue';

export default {
	props: {
		value: String,
		options: Object,
		isEditView: Boolean
	},
	data: function() {
		return {
		}
	},
	mixins: [utils],
	components: {
		's3': S3
	},
	computed: {
		input: vModelNested
	},
	methods: {
	}
}
</script>
